import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoyaltyIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0012 0.990234C10.0012 0.990234 11.5041 2.45083 13.8632 4.8057C15.1049 6.04865 17.9022 9.13274 17.9022 12.1993C17.9022 14.2433 16.2433 15.9007 14.2 15.9007C12.8582 15.9007 11.6855 15.1855 11.0394 14.1168L11.0379 14.1179C10.9725 14.0381 10.8645 13.9727 10.7473 13.9727C10.557 13.9727 10.3822 14.107 10.4035 14.2734C10.5451 15.3762 11.1658 18.0933 13.6125 19.0111H6.38794C8.83502 18.0933 9.45595 15.3762 9.59855 14.2734C9.61857 14.107 9.44533 13.9727 9.25479 13.9727C9.13493 13.9727 9.02829 14.0381 8.96291 14.1179V14.1168C8.31406 15.1855 7.14262 15.9007 5.80065 15.9007C3.75631 15.9007 2.09863 14.2433 2.09863 12.1993C2.09863 9.13274 4.89588 6.04865 6.14033 4.8057C8.4952 2.45083 10.0012 0.990234 10.0012 0.990234ZM11.0035 7.90122L10.001 4.8121L8.99875 7.90122H5.74727L8.37673 9.811L7.37321 12.8998L10.001 10.9902L12.629 12.8998L11.624 9.811L14.2525 7.90122H11.0035Z",
		fill: "black"
	})
});
export default SvgLoyaltyIcon;
